<template>
	<div class=" ">
		<el-card>
			<div slot="header" class="card_title">
				<span>标签新增</span>
			</div>
			<div class="add_main hidden_scroll">
				<div class="margin_top_20">
					<el-form
						label-position="right"
						:rules="rule"
						ref="formData"
						label-width="120px"
						:model="formData"
					>
						<el-form-item label="专题名称：" prop="name">
							<el-input v-model="formData.name" class="custom_input_350">
							</el-input>
						</el-form-item>
						<el-form-item label="专题英文名称：" prop="name_en">
							<el-input v-model="formData.name_en" class="custom_input_350">
							</el-input>
						</el-form-item>
						<el-form-item label="备注：">
							<el-input
								v-model="formData.notes"
								class="custom_input_350"
								type="textarea"
								:rows="4"
							>
							</el-input>
						</el-form-item>
						<el-form-item label="图片：">
							<p style="color: red; font-size: 18px">（尺寸要求16:9）</p>
							<div class="upload_img_div" v-if="formData.pic">
								<img
									style="width: 80%"
									:src="formData.pic"
									@click="uploadPicture(formData.pic)"
								/>
								<div class="upload_img_del">
									<img
										@click="removePicture"
										src="../../../assets/images/upload_img_del.png"
									/>
								</div>
							</div>

							<div v-else>
								<div class="el-upload__text">
									<img
										style="width: 100px"
										src="../../../assets/images/uploadImg.png"
										alt=""
										@click="uploadPicture(formData.pic)"
									/>
									<br /><em>点击加号上传</em></div
								>
							</div>
							<!-- 剪裁组件弹窗 -->
							<el-dialog
								title=""
								:visible.sync="cropperModel"
								width="1300px"
								center
								:append-to-body="true"
							>
								<template v-if="cropperModel">
									<cropper-image-new
										:Name="cropperName"
										:type="scale"
										@uploadImgSuccess="handleUploadSuccess"
										ref="child"
									>
									</cropper-image-new
								></template>
							</el-dialog>
						</el-form-item>

						<el-form-item label="语言" prop="language">
							<el-select v-model="formData.language" placeholder="请选择语言">
								<el-option label="简体中文" value="1"> </el-option>
								<el-option label="英语" value="2"> </el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<div class="flex justify_content_c align_items_c">
								<el-button
									type="primary"
									class="custom_btn_width_100"
									@click="submit('formData')"
									>保存</el-button
								>
								<el-button class="custom_btn_width_100" @click="$router.back()">
									返回
								</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import { validateNull } from "@/utils/validate";
import { addLabel, editLabel } from "@/api/article";
import { uploadImage } from "@/api/user";
export default {
	name: "",
	data() {
		return {
			rule: {
				name: [{ validator: validateNull, trigger: "blur", required: true }],
				// notes: [{ validator: validateNull, trigger: "blur", required: true }],
				language: [
					{ validator: validateNull, trigger: "change", required: true },
				],
				// pic: [{ validator: validateNull, trigger: "change", required: true }],
			},
			value: "",
			formData: {
				name: "",
				name_en: "",
				notes: "",
				pic: "",
				language: "",
				id: "",
			},
			placeholders: {
				province: "请选择省份",
				city: "请选择市",
				area: "请选择区或县",
			},
			//参数
			cropperModel: false,
			cropperName: "",
			scale: "0",
		};
	},
	created() {
		if (!this.$route.query.row) {
			this.clearFormAdd();
		} else {
			let row = this.$route.query.row;
			this.formData.name = row.name;
			this.formData.name_en = row.name_en;
			this.formData.notes = row.notes;
			this.formData.pic = row.pic;
			this.formData.language = row.language.toString();
			this.formData.id = row.id;
		}
	},
	methods: {
		//封面设置
		uploadPicture(name) {
			if (this.$route.query.type == "detail") {
				// 详情不支持编辑图片
			} else {
				this.cropperName = name;
				this.type = "1";
				this.cropperModel = true;
			}
		},
		removePicture() {
			this.formData.pic = "";
		},
		//图片上传成功后
		handleUploadSuccess(data) {
			this.cropperModel = false;
			this.formData.pic = data.url;
		},
		submit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					const that = this;
					if (this.$route.query.type) {
						editLabel(that.formData)
							.then((res) => {
								if (res.code == 200) {
									that.$router.back();
								} else {
								}
							})
							.catch((error) => {});
					} else {
						addLabel(that.formData)
							.then((res) => {
								if (res.code == 200) {
									that.$router.back();
								} else {
								}
							})
							.catch((error) => {});
					}
				} else {
					console.log("error submit!!");
					return false;
				}
			});
		},
		clearFormAdd() {
			for (let key in this.formData) {
				this.formData[key] = "";
			}
		},
	},
};
</script>

<style scoped>
.main {
	width: calc(100% - 40px);
}

.upload_img_div {
	display: flex;
}
.upload_img_del {
	margin-left: -15px;
	margin-top: -15px;
}
.upload_img_del img {
	width: 30px;
	height: 30px;
}
.add_main {
	width: 70%;
	height: 81vh;
	overflow-y: scroll;
	margin: 0 auto;
}
</style>
<style>
.distpicker-address-wrapper select {
	width: 255px !important;
	padding: 0px 10px !important;
	height: 35px !important;
	font-size: 18px !important;
	line-height: 35px !important;
}
</style>
